export default __webpack_public_path__ + "static/andy-a45e56dc4d6cd10011ff73b72809e255.jpg";